import { gql } from '@apollo/client';

const KEYBOARDING_CURRICULUM_ACTIVITY_FRAGMENT = gql`
  fragment BaseKeyboadingCurriculumActivity on KeyboardingCurriculumActivity {
    id
    curriculumId
    curriculumWeekId
    activityId
    sequenceNumber
    dayOfWeek
    enrichment
    spotCheck
    activity {
      title
      url
      name
      thumbnail {
        src
      }
      activityTypeVariant {
        name
        videos {
          device
          video {
            src
          }
        }
      }
    }
    curriculumWeek {
      week
      keys
      curriculumTheme {
        name
        id
        thumbnail {
          src
        }
      }
    }
  }
`;

export default KEYBOARDING_CURRICULUM_ACTIVITY_FRAGMENT;
